var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("GChart", {
    attrs: {
      settings: { packages: ["corechart", "treemap"] },
      type: "TreeMap",
      data: _vm.treemapChartdata,
      options: _vm.options
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }